export const ZENDESK_SNIPPET_ID = 'ze-snippet';
const ZENDESK_KEY = process.env.REACT_APP_ZENDESK_APP_ID;
if (!ZENDESK_KEY) {
  throw new Error('[Zendesk] Missing REACT_APP_ZENDESK_APP_ID');
}
export const ZENDESK_SNIPPET_SRC =
  `https://static.zdassets.com/ekr/snippet.js?key=${ZENDESK_KEY}`;

export function isZendeskApiReady() {
  return typeof window !== 'undefined' && typeof window.zE === 'function';
}

export function injectZendeskSnippetOnce() {
  return new Promise((resolve, reject) => {
    if (typeof window === 'undefined') return reject(new Error('No window'));

    const minimal = new URLSearchParams(window.location.search).get('minimal');

    // Skip Zendesk entirely in minimal mode
    if (minimal === 'true') {
      console.info('[Zendesk] Skipping init (minimal mode active)');
      return resolve();
    }

    // If already ready → resolve immediately
    if (isZendeskApiReady()) return resolve();

    // If script tag already exists, wait for readiness
    const existing = document.getElementById(ZENDESK_SNIPPET_ID);
    if (existing) return waitForReady(resolve, reject);

    // Create the script
    const script = document.createElement('script');
    script.id = ZENDESK_SNIPPET_ID;
    script.async = true;
    script.src = ZENDESK_SNIPPET_SRC;

    script.addEventListener('error', () =>
      reject(new Error('Zendesk snippet failed to load'))
    );

    // waiting until zE appears.
    script.addEventListener('load', () => waitForReady(resolve, reject));

    document.body.appendChild(script);
  });
}

function waitForReady(resolve, reject) {
  if (isZendeskApiReady()) return resolve();

  const started = Date.now();
  const timer = setInterval(() => {
    if (isZendeskApiReady()) {
      clearInterval(timer);
      resolve();
      return;
    }
    if (Date.now() - started > 10000) {
      clearInterval(timer);
      reject(new Error('Zendesk API did not become ready in time'));
    }
  }, 50);
}
